export default [
	{
		start: 0.05,
		end: 4,
		text: 'Qui sont ces gens ?! Il ne vous connaissent même pas...'
	}
]
